module.exports = require("/workspace/src/redux/store")